module.exports = __webpack_public_path__ + "static/media/login_icon.5ac55826.svg";